/**
 * Tier2Section — NDA-protected tier.
 * Mobile: 1-col list + full-width Unlock button.
 * Tablet: 2-col grid.
 * Desktop: 4-col grid + right-aligned Unlock button.
 *
 * - Outer box turns green border on NDA acceptance.
 * - Lock icon hidden when unlocked.
 * - Per-folder green tick after all docs in that folder accessed.
 */
import FolderItem from './FolderItem';
import { formatFolderDisplayName } from './utils';

const LockIcon = () => (
  <img src="/assets/images/pdp/lock.svg" alt="" width="20" height="20" aria-hidden="true" />
);

const ButtonLockIcon = () => (
  <img src="/assets/images/pdp/w_lock.svg" alt="" width="20" height="20" aria-hidden="true" />
);

const Tier2Section = ({ isNDAAccepted, user, tier2Folders, expandedFolders, fileErrors, onFolderToggle, onFileActivate, onUnlockVault, isFolderComplete }) => {
  const isUnlocked = !!user && isNDAAccepted === 'Y';
  const hasFolders = Array.isArray(tier2Folders) && tier2Folders.length > 0;

  return (
    <div className={`ddv-tier-card ddv-tier-card--tier2${isUnlocked ? ' ddv-tier-card--unlocked' : ''}`}>
      <div className="ddv-tier-header ddv-tier-header--tier2">
        <div className="ddv-tier-header-row">
          <h3 className="ddv-tier-title">Requires NDA</h3>
          {!isUnlocked && <LockIcon />}
        </div>
      </div>
      <div className="ddv-tier-body">
        {!hasFolders ? (
          <p className="ddv-empty">No documents available</p>
        ) : (
          <>
            <div className="ddv-folder-grid ddv-folder-grid--tier2">
              {tier2Folders.map(([folderName, docsMap]) => {
                const isExpanded = isUnlocked && expandedFolders instanceof Set && expandedFolders.has(folderName);
                const isComplete = isUnlocked && isFolderComplete(docsMap);
                return (
                  <FolderItem
                    key={folderName}
                    folderName={formatFolderDisplayName(folderName)}
                    docs={Object.values(docsMap || {})}
                    isExpanded={isExpanded}
                    isLocked={!isUnlocked}
                    isComplete={isComplete}
                    fileErrors={fileErrors}
                    onToggle={() => isUnlocked && onFolderToggle(folderName)}
                    onFileActivate={onFileActivate}
                  />
                );
              })}
            </div>
            {!isUnlocked && (
              <div className="ddv-tier2-footer">
                <button type="button" className="ddv-unlock-btn" onClick={onUnlockVault}>
                  <ButtonLockIcon />
                  Unlock Vault
                </button>
              </div>
            )}
          </>
        )}
      </div>
    </div>
  );
};

export default Tier2Section;
